<template>
    <div v-if="session.current_amount > 0">
        <DataTable :value="session.items" class="p-datatable-sm" breakpoint="992px" responsiveLayout="stack"
            :tableClass="tableClass" id="history-table" stripedRows>
            <template #header>
                <div>
                    <div class="d-flex border-bottom">
                        <p class="m-0 mr-4"><span v-if="has_linked">{{ session.company_name }} - </span> Opened at {{
                            moment(session.opened_at).format('M/D/YY h:mm A') }}</p>
                        <p v-if="!session.closed_at" class="m-0">Current Amount: {{ formatDollars(session.current_amount) }}
                        </p>
                        <p v-if="session.closed_at" class="mb-2">Closed at {{ closedAt }}</p>
                    </div>
                    <p class="mt-2 mb-0" v-if="session.closed_at">Cash remaining in drawer: <span class="text-success">${{
                        closedLeaving }}</span></p>
                    <p class="mb-0" v-if="session.items"> Total Transactions: {{ session.items.length }}</p>
                    <p v-if="session.items">Total $ Amount of Transactions: <span class="text-success">${{
                        totalTransactionDollars }}</span></p>
                </div>
                <div v-if="session.items.length" @click="expanded = !expanded"
                    class="expand-table text-primary d-flex align-items-center cursor-pointer mb-2">
                    <i :class="iconClass" class="fas mr-2"></i>
                    <p class="m-0">{{ iconText }}</p>
                </div>
            </template>

            <template v-if="session.items.length">
                <Column field="date" header="Date">
                    <template #body="slotProps">
                        {{ moment(slotProps.data.date).format('M/D/YY h:mm A') }}
                    </template>
                </Column>
                <Column field="description" header="Description"></Column>
                <Column field="customer" header="Customer"></Column>
                <Column class="table-right" field="payment_amount" header="Amount" headerClass="header-right">
                    <template #body="slotProps">
                        {{ formatDollars(slotProps.data.payment_amount) }}
                    </template>
                </Column>
                <Column class="table-right" field="credit_amount" header="Tendered" headerClass="header-right">
                    <template #body="slotProps">
                        {{ formatDollars(slotProps.data.credit_amount) }}
                    </template>
                </Column>
                <Column class="table-right" field="debit_amount" header="Change" headerClass="header-right">
                    <template #body="slotProps">
                        {{ formatDollars(slotProps.data.debit_amount > 0 ? slotProps.data.debit_amount : 0) }}
                    </template>
                </Column>
                <Column class="table-right" header="Check" headerClass="header-right">
                    <template #body="slotProps">
                        <div v-if="slotProps.data.is_check">
                            <button class="btn btn-link" data-toggle="modal" data-target="#editCheckNumber"
                                @click="setCheckNumberEditFormValues(slotProps.data)">
                                {{ slotProps.data.check_number ? slotProps.data.check_number : 'Enter' }}
                            </button>
                        </div>
                    </template>
                </Column>
            </template>
        </DataTable>

        <jet-dialog-modal icon="fas fa-address-book" id="editCheckNumber">
            <template #title>Check Number</template>
            <template #content>
                <div class="form-group">
                    <input class="form-control" type="text" v-model="formCheckNumber.check_number" />
                    <div v-if="formCheckNumber.errors.check_number">{{ formCheckNumber.errors.check_number }}</div>
                </div>
            </template>
            <template #footer>
                <jet-button @click="saveCheckNumber">Save</jet-button>
                <jet-danger-button data-dismiss="modal" class="ml-2">Cancel</jet-danger-button>
            </template>
        </jet-dialog-modal>
    </div>
</template>

<script>
import moment from 'moment'
import Helpers from '@/Helpers.js'
import JetDialogModal from '@/Jetstream/DialogModal'
import JetButton from '@/Jetstream/Button'
import JetDangerButton from '@/Jetstream/DangerButton'

export default {
    components: { JetDialogModal, JetButton, JetDangerButton },
    data() {
        return {
            expanded: false,
            showEditCheckNumberModal: false,
            formCheckNumber: this.$inertia.form({
                check_number: null,
            }),
        }
    },
    props: {
        session: Object,
        has_linked: Boolean
    },
    created() {
        this.moment = moment
    },
    computed: {
        iconClass() {
            return this.expanded ? 'fa-minus' : 'fa-plus'
        },
        iconText() {
            return this.expanded ? 'Hide this table' : 'Expand this table'
        },
        closedLeaving() {
            return this.formatCurrency(this.session.close_amount > 0 ? this.session.close_amount : 0)
        },
        closedAt() {
            return this.moment(this.session.closed_at).format('M/D/YY h:mm A')
        },
        totalTransactionDollars() {
            let total = 0
            this.session.items.forEach(item => total += item.payment_amount)
            return this.formatCurrency(total)
        },
        tableClass() {
            return `${this.expanded ? 'expanded' : ''} transaction-table`
        }
    },
    methods: {
        formatCurrency: Helpers.formatCurrency,
        setCheckNumberEditFormValues(data) {
            this.formCheckNumber.id = data.id;
            this.formCheckNumber.check_number = data.check_number;
        },
        saveCheckNumber() {
            this.formCheckNumber.put(route('mtd.updateCheckNumber', this.formCheckNumber.id), {
                preserveScroll: true,
                onSuccess: () => $('#editCheckNumber').modal('hide'),
            });
        }
    }
}
</script>
